import { Typography } from '@/components/common';
import * as React from 'react';

interface FilterContainerProps {
	title: string;
	children: React.ReactNode;
}
export const FilterContainer: React.FC<FilterContainerProps> = ({
	title,
	children,
}) => {
	return (
		<div className="bg-white rounded-[32px] shadow-chatBox p-4 w-full lg:w-[343px]">
			<Typography type="semibold-16">{title}</Typography>
			<div className="h-[384px] overflow-y-auto scroll-custom mt-4">
				{children}
			</div>
		</div>
	);
};
